import React from 'react';
import ReactDOM from 'react-dom';
import App from './routes/App';
import {IntlProvider} from "react-intl";
import reportWebVitals from './reportWebVitals';

import messages_es from "./translations/es.json";
import messages_en from "./translations/en.json";

const messages = {
    'es': messages_es,
    'en': messages_en
};
// const  language = navigator.language.split(/[-_]/)[0];
//l/et url = new URL(window.location);
// let params = new URLSearchParams(url.search.slice(1));
//const  language = url.get('lang');
let params = new URLSearchParams(document.location.search.substring(1));
let language = params.get('lang');

let lang1 = 'en';
switch (language) {
  case 'es':
    lang1 = language;
    break;
  case 'en':
    lang1 = language;
    break;
  default:
    lang1 = 'es';
    break;

}
ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale={lang1} messages={messages[lang1]}>
      <App />
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
